export default "__VITE_ASSET__yy7Kh8oE__"